// extracted by mini-css-extract-plugin
export default {"content":"CreatePost_content__5hHV0","btn":"CreatePost_btn__25wPZ"};